import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Button from 'components/common/Button';
import Colors from 'constants/colors';
import i18n from 'i18n';
import { serif } from 'constants/font-styles';
import previewSize from 'constants/preview-size';
import { min, throttle } from 'lodash';
import Image from 'components/common/Image';
import imgMessageCardPC1x from 'assets/images/PC/@1x/img_preview.png';
import imgMessageCardPC2x from 'assets/images/PC/@2x/img_preview@2x.png';
import imgMessageCardSP2x from 'assets/images/SP/@2x/img_preview@2x.png';
import imgMessageCardSP3x from 'assets/images/SP/@3x/img_preview@3x.png';

class dialog extends React.Component {
  constructor() {
    super();
    this.state = { visible: true }

    this.dialogBodyRef = React.createRef();
    this.previewRef = React.createRef();

    this.resizeEvent = throttle(event => this.scalePreview(), 100);
  }

  componentDidMount() {
    this.scalePreview();
    window.addEventListener('resize', this.resizeEvent);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeEvent);
  }

  scalePreview = () => {
    let dialog = this.dialogBodyRef.current
    let preview = this.previewRef.current
    let scaleWidth = dialog.clientWidth / previewSize.maxWidth
    let scaleHeight = dialog.clientHeight / previewSize.maxHeight
    let scale = min([scaleWidth, scaleHeight, 1.0])
    preview.style.transform = `scale(${scale}) translate(-50%, -50%)`;
  }

  close = () => {
    const { resolve, cleanup } = this.props;
    resolve(true);
    cleanup();
  }

  confirm = () => {
    const { resolve, cleanup } = this.props;
    this.setState({ visible: false }, () => {
      resolve(true);
      cleanup();
    });
  }

  render() {
    const { visible } = this.state;
    const { className, message } = this.props;

    return (
      <div className={`${className} ${visible ? '' : 'hidden'}`}>
        <div className="dialog">
          <Button
            buttonType="Close"
            onClick={this.close}
            className="btn-close"
          />
          <div ref={this.dialogBodyRef} className="body">

            <div ref={this.previewRef} className="preview">
              <div className="preview-canvas">
                <div className="preview-image">
                  <Image
                    pc1x={imgMessageCardPC1x}
                    pc2x={imgMessageCardPC2x}
                    sp2x={imgMessageCardSP2x}
                    sp3x={imgMessageCardSP3x}
                    alt="ic_btn_arrow2_sp"
                  />
                </div>
                <p className="preview-message">{ message }</p>
              </div>
            </div>

          </div>
          <footer>
            <Button buttonType="H" className="ok" onClick={this.confirm}>{i18n.t('common:ok')}</Button>
          </footer>
        </div>
      </div>
    );
  }
}

const commonStyle = css`
  position: fixed;
  display: block;
  background-color: rgba(0,0,0,0.4);
  width: 100%;
  height: 100%;
  z-index: 9999;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &.hidden {
    display: none;
  }

  .dialog {
    background-color: ${Colors.white1};
    border: 1px solid ${Colors.black1};
    border-radius: 15px;
    position: relative;

    .btn-close {
      display: none;
    }

    .body {
      position: relative;

      .preview {
        overflow: hidden;
        position: absolute;
        width: ${previewSize.maxWidth}px;
        height: ${previewSize.maxHeight}px;
        transform-origin: 0 0;
        top: 50%;
        left: 50%;
        margin: auto;
      }

      .preview-canvas {
        position: relative;
        display: inline-block;
        width: 100%;
        height: 100%;

        .preview-message {
          position: absolute;
          display: inline-block;
          top: 151px;
          left: 106px;
          white-space: pre-wrap;
          width: 500px;
          height: 260px;
          margin: 0;
          font-family: ${serif};
          font-size: 22px;
          line-height: 26px;
          letter-spacing: 3px;
        }

        .preview-image {
          display: inline-block;
          width: 100%;
          height: 100%;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

    }
    footer {
      text-align: center;
      border-top: 1px dashed ${Colors.gray2};
      display: flex;
      justify-content: center;
      align-items: center;

      button {
        cursor: pointer;
      }

    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .dialog {
    width: calc(100% - 160px);
    height: calc(100% - 160px);
    max-width: 774px;
    max-height: 762px;
    margin: 80px;
    border-radius: 16px;
    padding: 32px;
  }

  .body {
    height: calc(100% - 76px);
  }

  footer {
    margin-top: 32px;
    padding: 18px 0;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .dialog {
    width: calc(100% - 24px);
    height: calc(100% - 48px);　
    max-height: 615px;
    margin: 24px;
    border-radius: 8px;
    padding: 0 16px;
  }

  .body {
    height: calc(100% - 73px);
    position: relative;
  }

  footer {
    padding: 16px 0 0;
  }
`;

const Dialog = applyStyles(dialog)(commonStyle, pcStyle, spStyle);

const MessgeCardPreviewDialog = ({ message }) => {
  const wrapper = document.body.appendChild(document.createElement('div'));
  const cleanup = () => {
    unmountComponentAtNode(wrapper);
    return setTimeout(() => wrapper.remove());
  };
  const promise = new Promise((resolve, reject) => {
    try {
      render(
        <Dialog
          cleanup={cleanup}
          resolve={resolve}
          message={message}
        />,
        wrapper
      );
    } catch (e) {
      cleanup();
      reject(e);
      throw e;
    }
  });
  return promise;
};

export default MessgeCardPreviewDialog;



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/components/MessageCardPreviewDialog.js